var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalender = function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.467 1.399h5.066V.732a.4.4 0 0 1 .8 0v.673a1.467 1.467 0 0 1 1.334 1.46V8.2c0 .81-.657 1.466-1.467 1.466H1.8C.99 9.665.333 9.01.333 8.2V2.865c0-.765.586-1.393 1.334-1.46V.732a.4.4 0 1 1 .8 0v.667Zm-.4.8H1.8a.667.667 0 0 0-.667.666V3.8h7.734v-.934A.667.667 0 0 0 8.2 2.2H2.067Zm-.934 2.4v3.6c0 .368.299.666.667.666h6.4a.667.667 0 0 0 .667-.666v-3.6H1.133Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgCalender;